var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.Settings = OCS.Settings || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.UIMenu = new Class({
    Implements: [OCS.WxBriefing.Classes.Manager],
    element: null,
    manager_name: 'UI_Menu',
    failed_menu_attemps: 0,
    bound_methods: {},
    menu_available: false,
    options: {
        debug: false,
        menu_container_selector: "#header nav ul.weather_briefing_menu_container",
        menu_json_location: OCS.Constants.CONTENT_URL + "/mesonet/weather_briefing/menu." + OCS.Settings.env + ".2.html",
        menu_json_backup_location: "/index.php/api/weather_briefing/menu/format/html/version/2",
        update_url_event_string: 'update_url_event',
        max_failed_menu_attemps: 3
    },
    initialize: function (options) {
        if (!this.manager_name) {
            return null;
        }
        if (OCS.WxBriefing.Live[this.manager_name]) {
            return OCS.WxBriefing.Live[this.manager_name];
        }
        this.setOptions(options);
        this.element = $$(this.options.menu_container_selector)[0];
        if (this.element) {
            this.element.addClass('main_menu');
        }
        this.init_ajax_calls();
        this.get_myproducts_menu();
        OCS.WxBriefing.Live[this.manager_name] = this;
    },
    /*
     * Initialization and corresponding uninitialization methods
     */
    init_ajax_calls: function () {
        var am = OCS.Functions.get_ajax_manager();
        am.request("fetch_menu", {
            url: this.options.menu_json_location,
            dataType: "html",
            method: "GET",
            storeCompletedReq: 0,
            onSuccess: function (response) {
                var data = response.text;
                if (data && data.length > 2) {
                    this.build_menu(data);
                } else {
                    this.failed_menu_attemps++;
                    this.fetch_backup_menu();
                }
            }.bind(this),
            onFailure: function (data) {
                this.failed_menu_attemps++;
                this.fetch_backup_menu();
            }.bind(this)
        });
        am.request("fetch_backup_menu", {
            url: this.options.menu_json_backup_location,
            dataType: "html",
            method: "GET",
            storeCompletedReq: 0,
            onSuccess: function (response) {
                var data = response.text;
                if (data && data.length) {
                    this.build_menu(data);
                } else {
                    this.failed_menu_attemps++;
                    alert('The menu could not be retrieved. Please contact operator@mesonet.org for help.');
                }
            }.bind(this),
            onFailure: function (response) {
                this.failed_menu_attemps++;
                if (this.failed_menu_attemps < this.options.max_failed_menu_attemps) {
                    response.request.send();
                } else {
                    alert("Unable to retrieve the menu. Giving up after " + response.failed_attempts + " failed attempts. Please contact operator@mesonet.org for help.");
                }
            }.bind(this)
        });
    },
    /*
     * Fetch related methods
     */

    fetch_menu: function () {
        var am = OCS.Functions.get_ajax_manager();
        OCS.console.debug_text('UIMenu: Attempting to fetch the menu.');
        if (this.failed_menu_attemps > this.options.max_failed_menu_attemps) {
            alert('The menu could not be retrieved. Please contact operator@mesonet.org for help.');
            return;
        }
        jQuery('header > nav span.menu_spinner').addClass('spinner');
        var req = am.request("fetch_menu");
        if (req) {
            req.send();
        }
    },
    fetch_backup_menu: function () {
        var am = OCS.Functions.get_ajax_manager();
        if (this.failed_menu_attemps > this.options.max_failed_menu_attemps) {
            alert('The menu could not be retrieved. Please contact operator@mesonet.org for help.');
            return;
        }
        var req = am.request("fetch_backup_menu");
        if (req) {
            req.send();
        }
    },

    /*
     * Actions
     */
    build_menu: function (data) {
        OCS.console.debug_text('UIMenu: Attempting to build the menu.');
        try {
            if (!OCS.Utilities.is_empty(data)) {
                this.clear_menu();
                var parsed_data = OCS.WxBriefing.Live.UI.replace_url_template_text(data);
                var menu = Elements.from(parsed_data);
                menu.each(function (horizontal_menu) {
                    new OCS.WxBriefing.Classes.HorizontalMenu(horizontal_menu, {container: this.element});
                }.bind(this));
                $$('nav span.menu_spinner.spinner').removeClass('spinner');
                this.get_myproducts_menu().build_myproducts();
                this.set_menu_available(true);
            } else {
                this.fetch_backup_menu();
            }
        } catch (err) {
            this.failed_menu_attemps++;
            OCS.console.debug_text("Menu Build Error: " + err.message);
            OCS.console.debug_text(err);

            this.fetch_backup_menu();
        }
    },
    clear_menu: function () {
        if (this.element) {
            this.element.getChildren().each(function (menu_item) {
                var menu_obj = menu_item.retrieve('menu_obj');
                if (menu_obj) {
                    menu_obj.destroy();
                } else {
                    menu_item.destroy();
                }
            });
        }
    },
    remove_menu_underlay: function (e) {
        var underlay = new OCS.WxBriefing.Classes.MenuUnderlay();
        underlay.hide();
    },
    reset_menu: function (options) {
        var keep_submenu = false;
        var keep_myproducts = false;
        var search_results_open = false;
        if (options) {
            if (options.keep_submenu) {
                keep_submenu = true;
            }
            if (options.keep_myproducts) {
                keep_myproducts = true;
            }
            if (options.search_results_open) {
                search_results_open = true;
            }
        }
        var hmenu = new OCS.WxBriefing.Classes.HorizontalMenu();
        var menu_obj;
        if (!keep_submenu) {
            $$("." + hmenu.options.element_class_name).each(function (li) {
                menu_obj = new OCS.WxBriefing.Classes.HorizontalMenu(li);
                menu_obj.on_deactivate();
            });
        }

        var vmenu = new OCS.WxBriefing.Classes.VerticalMenu();
        $$("." + vmenu.options.element_class_name).each(function (li) {
            menu_obj = new OCS.WxBriefing.Classes.VerticalMenu(li);
            menu_obj.on_deactivate();
        });

        if (!keep_myproducts) {
            this.get_myproducts_menu().on_deactivate();
        }
        OCS.WxBriefing.Functions.get_preview_window().hide();

        if (!search_results_open) {
            OCS.WxBriefing.Functions.get_search_manager().finish_search();
        }


    },
    show_menu_underlay: function () {
        var underlay = new OCS.WxBriefing.Classes.MenuUnderlay();
        underlay.show();
    },
    /*
     * Event Handler methods
     */

    handle_reset_menu: function (data) {
        this.reset_menu(data);
    },

    /* 
     * Get and set methods 
     */
    get_myproducts_menu: function () {
        return new OCS.WxBriefing.Classes.MyProductsMenu(null, {container: this.element});
    },
    get_default_config: function () {
        var default_config = this.get_myproducts_menu().get_my_default_config()
        if (default_config) {
            return default_config;
        }
        if (this.element) {
            var default_el = this.element.getElement('[data-default_configuration="1"]');
            if (default_el) {
                return default_el.getProperty('data-href');
            }
        }
        return false;


    },
    set_menu_available: function (cond) {
        this.menu_available = cond;
        if (cond) {
            this.fireEvent('menu_available', this);
        }
    },
    set_debug: function (cond) {
        this.options.debug = cond;
    },
    /* 
     * destroy methods
     */
    destroy: function () {
        this.reset_menu();
        this.clear_menu();
        if (this.element) {
            this.element.removeClass('main_menu');
        }
        this.element = null;
        var am = OCS.Functions.get_ajax_manager();
        am.remove_request('fetch_menu');
        am.remove_request('fetch_backup_menu');
        delete OCS.WxBriefing.Live[this.manager_name];
    }
}); // End OCS.WxBriefing.Classes.UIMenu
